import { Toast } from 'vant'
import MySwiper from '@/components/MySwiper.vue';
import NavBar from '@/components/Nav.vue';

import functions from '@/functions.js';
import enums from '@/configs/enums.js';

import Draw from '@/components/Draw.vue'

export default {
    name: 'IndexPage',
    components: {
        MySwiper,
        NavBar,
        Draw
    },
    data() {
        return {
            banners: [],
            keyword: '',
            showLogin: true,
            searchShow: false,
            state: '',
            states: enums.productState,
            types: enums.productType,
            page: 1,
            more: true,
            loading: false,
            products: [],
            subscribes: [],
            raffleProducts: [],
            subscribeLoading: false,
            dateFormat: functions.dateFormat,
            showWelfareAlert: false,
            showWelfareInfo: false,
            showGoTopBtn: false,
            raffTimer: null,
            goTopTimer: null,
            welfare: {},
            notices: [],
            noticeTimer: null,
            noticeIndex: 0
        }
    },
    created() {
        if (this.$store.state.authorizationTime > new Date().getTime() && ! this.$store.state.welfareShowed) {
            this.$http.get('welfare/waiting').then(result => {
                this.welfare = result.data.welfare;
                this.showWelfareAlert = result.data.welfare ? true : false;
                this.$store.state.welfareShowed = this.showWelfareAlert;
            });
        }
        this.$http.get('picture/' + enums.picturePosition.banner).then(result => {
            this.banners = result.data.pictures;
        })
        this.getProductList();
        this.$http.get('notice/index').then(result => {
            this.notices = result.data.notices;
            if (this.notices.length) {
                this.noticeTimer = setInterval(() => {
                    this.noticeIndex = this.noticeIndex == this.notices.length - 1 ? 0 : this.noticeIndex + 1;
                }, 2500);
            }
        })
    },
    mounted() {
        window.addEventListener('scroll', this.scroll, true);
    },
    unmounted() {
        clearInterval(this.raffTimer);
        clearInterval(this.goTopTimer);
        clearInterval(this.noticeTimer);
        window.removeEventListener('scroll', this.scroll, true);
    },
    methods: {
        prefixZero(number) {
            return (number < 10 ? '0' : '') + number;
        },
        goTop() {
            let value = (document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop) / 20;
            this.goTopTimer = setInterval(() => {
                let newTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
                let newValue = newTop - value;
                document.documentElement.scrollTop = newValue;
                if (newValue <= 0) {
                    clearInterval(this.goTopTimer);
                }
            }, 20);
        },
        getProductList() {
            if (this.more && ! this.loading) {
                this.loading = true;
                this.$http.get('product', {params: {subscribes: true, state: this.state, page: this.page}}).then(result => {
                    this.page++;
                    this.more = result.data.more;
                    this.products = this.products.concat(result.data.products);
                    this.subscribes = this.subscribes.concat(result.data.subscribes);
                    let nowTime = Date.parse(new Date) / 1000;
                    this.products.forEach(product => {
                        if (product.raffle) {
                            let raffleTime = Date.parse(new Date(product.raffle.timeline.subscribe_start)) / 1000;
                            if (raffleTime >= nowTime) {
                                let raffleDiff = raffleTime - nowTime;
                                product.raffle.diff = {hour: Math.floor(raffleDiff / 3600), minute: Math.floor(raffleDiff % 3600 / 60), second: Math.floor(raffleDiff % 60)};
                                this.raffleProducts.push(product);
                            }
                            
                        }
                    })
                    // 抽签倒计时
                    this.raffTimer = setInterval(() => {
                        this.raffleProducts.forEach(product => {
                            if (product.raffle.diff && ! product.raffle.subscribe_start_active) {
                                product.raffle.diff.second--;
                                if (product.raffle.diff.second < 0) {
                                    product.raffle.diff.minute--;
                                    product.raffle.diff.second = 59;
                                    if (product.raffle.diff.minute < 0) {
                                        product.raffle.diff.hour--;
                                        product.raffle.diff.minute = 59;
                                    }
                                }
                                if (product.raffle.diff.hour < 0 || product.raffle.diff.minute < 0 || product.raffle.diff.second < 0) {
                                    product.raffle.diff = false;
                                }
                            }
                        })
                    }, 1000);
                }).finally(() => {
                    this.loading = false;
                })
            }
        },
        toggleSubscribe(id) {
            if (this.subscribes.indexOf(id) == -1 && ! this.subscribeLoading) {
                this.subscribeLoading = true;
                this.$http.put('product/' + id + '/subscribe').then(() => {
                    if (this.subscribes.indexOf(id) > -1) {
                        this.subscribes.splice(this.subscribes.indexOf(id), 1);
                    } else {
                        this.subscribes.push(id)
                    }
                    Toast('预约成功');
                }).finally(() => {
                    this.subscribeLoading = false;
                })
            }
        },
        search() {
            this.$router.push('/search?keyword=' + this.keyword);
        },
        scroll() {
            let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            this.showGoTopBtn = scrollTop > 1000;
            if (document.documentElement.scrollHeight - scrollTop - document.documentElement.clientHeight <= 100) {
                this.getProductList();
            }
        },
        selectState(value) {
            this.state = value;
            this.loading = false;
            this.page = 1;
            this.more = true;
            this.products = [];
            this.getProductList();
        },
        toggleSearch() {
            this.searchShow = ! this.searchShow;
        }
    }
}